interface BetaAccessUser {
  betaTester?: boolean | null;
  betaApplicationStatus?: string | null;
  otaChannel?: string | null;
}

export function hasBetaAccess(user?: BetaAccessUser | null): boolean {
  return Boolean(
    user?.betaTester ||
    user?.betaApplicationStatus === "approved" ||
    user?.otaChannel === "beta" ||
    user?.otaChannel === "alpha"
  );
}

export function hasFeatureAccess(betaOnly: boolean, user?: BetaAccessUser | null): boolean {
  return !betaOnly || hasBetaAccess(user);
}
